import ErrorMonitorDatatable from './error-monitor-datatable/error-monitor-datatable.component.vue';
import ErrorMonitor from './error-monitor.view.vue';

export default [
  {
    path: '/error-monitor',
    component: ErrorMonitor,
    children: [
      {
        path: '/error-monitor',
        name: 'ErrorMonitorDatatable',
        component: ErrorMonitorDatatable,
      },
    ],
  },
];
